import { PensionOption } from "../../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { CrystallisationOption } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/CrystallisationOption";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";

export const DrawdownTypeOptionsMap = {
    [DrawdownType.Flexible]: "Flexi-access single",
    [DrawdownType.Regular]: "Regular crystallisation",
    [DrawdownType.Capped]: "Capped single",
};

export const PensionOptionMap = {
    [PensionOption.Drawdown]: "Drawdown",
    [PensionOption.UFPLS]: "Uncrystallised funds pension lump sum",
};

export enum ChooseAssetsToSellFor {
    Drawdown,
    Income,
}

export const crystallisationAmountErrorMessage = {
    valueToCrystalliseIsZero:
        "The value available to crystallise is zero so you cannot complete the crystallisation at this time.",
    inputIsZeroAndLessThanUncrystallised:
        "Please enter a crystallisation amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputIsZeroAndEqualUncrystallised:
        "Please enter a crystallisation amount that is greater than zero and less than the value available to crystallise.",
    inputEqualValueToCrystallise:
        'The amount you have entered is equal to the total value available to crystallise. If you want to crystallise the whole amount, please choose "Full" for your crystallisation options.',
    inputGreaterThanValueToCrystalliseAndLessThanUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a crystallisation amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputGreaterThanValueToCrystalliseAndEqualUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a crystallisation amount that is greater than zero and less than the value available to crystallise.",
};

export const drawdownDetailsMessage = {
    crystallisationOptionErrorMessage:
        "You will need to cancel the process because the client has entitlements that require this to be a full crystallisation, but the value available to crystallise is less than the uncrystallised fund value.",
    crystallisationOptionFullErrorMessage: "Can not select full crystallisation.",
    LTAInputErrorMessage:
        "Please enter a value for the LTA crystallised off platform that is equal to or greater than 0%",
    LTAMaxErrorMsg: "Please enter a value for the LTA crystallised off platform that is between 0% and 999.99%.",
    regularCrystallisationAmountErrorMessage: "Please enter an amount that is greater than zero",
};

export const CrystallisationOptions = [CrystallisationOption.Full, CrystallisationOption.Partial];
export const CrystallisationOptionsMap = {
    [CrystallisationOption.Full]: "Full",
    [CrystallisationOption.Partial]: "Partial",
};

export const LTADetailHeading = {
    previousLTA: "Lifetime allowance (LTA) previously used in this account",
    LTABefore2006: "LTA used by benefits that commenced before 6 April 2006",
    availableLTA: "Available LTA",
    otherLTA: "Other LTA used you need to tell us about",
    LTAByThisCrystallisation: "LTA % used by this crystallisation",
    LTAInTotal: "LTA % used in total following this crystallisation",
    crystallisationAmountSubjectToLTAExcessCharge: "Amount of crystallisation subject to LTA excess charge",
    estimateLTAForInitialCrystallisation: "Estimated LTA % usage for initial crystallisation",
    estimateLTAPerRegularCrystallisation: "Estimated LTA % usage per regular crystallisation",
    estimateAvailableLTAInAYear: "Estimated available LTA after a year",
    estimateLTAUsedInAYear: "Estimated LTA that will be used after a year",
    estimateTotalLTAUsedInAYear: "Estimated total LTA that will be used after a year",
    estimatedChargeableCrystallisation: "Estimated chargeable portion of crystallisation after a year",
    crystallisationChargeablePortion: "Chargeable portion of crystallisation",
};

export const LTADetailTooltiopMessage = {
    previousLTA: "TBC by Pension pod/SL props",
    otherLTA: "TBC by Pension pod/SL props",
    LTAByThisCrystallisation:
        "This is the percentage of the lifetime allowance for the current tax year that will be used by your client's crystallisation.",
    LTAInTotal:
        "This is the total lifetime allowance for the current tax year that will be used once this crystallisation is added to any previous crystallisations taken by your client.",
    estimatedChargeableCrystallisation:
        "This is the estimated amount that we will crystallise in order to achieve the required income",
};
